import { getCurrency } from 'services/currencies'

export const RUB = '₽'
export const USD = '$'
export const EUR = '€'
export const currencies = [
  { name: USD, value: USD },
  { name: RUB, value: RUB },
  { name: EUR, value: EUR }
]
export const DEFAULT_RATE_CURRENCY = {
  rubRate: 1,
  usdRate: 1,
  eurRate: 1,
  type: getCurrency() || USD
}
